import React from "react";
import { ChevronDown } from "react-feather";
import SpendingAnalysisCard from "../analysis/SpendingAnalysisCard";
import DashboardStats from "../components/DashboardStats";
import CashflowCard from "../components/CashflowCard";
import IncomeExpenseCard from "../components/IncomeExpenseCard";
import { NetWorthCard, CreditCardsCard, BudgetPlanCard } from "../components/DashboardCards";
import { useTheme } from "../theme/ThemeContext";

const Dashboard = () => {
  const { tokens, fonts } = useTheme();

  return (
    <div style={styles.container}>
      <div style={styles.headerRow}>
        <div>
          <span
            style={{
              ...styles.kicker,
              fontFamily: fonts.display,
              backgroundColor: tokens.accent,
              color: tokens.accentContrast,
            }}
          >
            OVERVIEW
          </span>
          <h1 style={{ ...styles.heading, fontFamily: fonts.display, color: tokens.textPrimary }}>
            Good to see you back
          </h1>
          <p style={{ ...styles.subheading, color: tokens.textMuted }}>
            Here's where your money stands today.
          </p>
        </div>
        <button
          style={{
            ...styles.dateButton,
            backgroundColor: tokens.surface,
            border: `1px solid ${tokens.surfaceBorder}`,
            boxShadow: tokens.cardShadow,
            color: tokens.textPrimary,
          }}
        >
          This Month
          <ChevronDown size={14} color={tokens.textMuted} />
        </button>
      </div>

      <DashboardStats />
      <SpendingAnalysisCard />

      <div style={styles.contentGrid}>
        <div style={{ gridColumn: "span 2" }}>
          <CashflowCard />
        </div>
        <div>
          <NetWorthCard />
        </div>
        <div>
          <IncomeExpenseCard />
        </div>
        <div>
          <CreditCardsCard />
        </div>
        <div>
          <BudgetPlanCard />
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "0px 24px 40px",
    maxWidth: "95%",
    margin: "0 auto",
  },
  headerRow: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginBottom: 24,
    flexWrap: "wrap",
    gap: 16,
  },
  kicker: {
    display: "inline-block",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.12em",
    padding: "5px 14px",
    borderRadius: 999,
    marginBottom: 12,
  },
  heading: {
    margin: 0,
    fontSize: 28,
    fontWeight: 700,
    letterSpacing: "-0.01em",
  },
  subheading: {
    margin: "6px 0 0",
    fontSize: 14,
  },
  dateButton: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "10px 16px",
    borderRadius: 10,
    fontWeight: 600,
    fontSize: 13,
    cursor: "pointer",
  },
  contentGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 24,
    alignItems: "start",
  },
};

export default Dashboard;
